module.exports = __webpack_public_path__ + "static/media/Stranger Ways.d37ec48c.jpg";